<template>
  <div class="password-form">
    <h2>请输入密码</h2>
    <form @submit.prevent="onSubmit">
      <input type="text" v-model="password" />
      <button type="submit">确定</button>
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  emits: ["submit"],
  setup(_, { emit }) {
    const password = ref<string>("");

    const onSubmit = () => {
      emit("submit", password.value);
    };

    return {
      password,
      onSubmit,
    };
  },
});
</script>
